const attachment = {
  attachment: 'Вложение',
  'attachment.attachment': 'Вложение',
  'attachment.accepttext': 'Поддерживаемые форматы: xlsx/jpg/png/pdf, размер до 10МБ',
  'attachment.errsize': 'Размер файла должен быть менее 10МБ',
  'attachment.errtype': 'Недопустимый формат файла',
  'attachment.uploadfile': 'Загрузить файл',
};

export default attachment;
